import { type FC } from 'react';
import { Button, Stack, Text } from '@chakra-ui/react';
import { translate } from '../../../../constants/translation';

interface Props {
  resetFilters: () => void;
}

const NoTripsFound: FC<Props> = ({ resetFilters }) => {
  return (
    <Stack className="no-trips-container" spacing="3">
      <Text className="text-header">{translate('NO_TRIPS')}</Text>
      <Text textAlign="center">{translate('NO_MATCH_ON_SEARCH')}</Text>
      <Button variant="secondary" onClick={resetFilters}>
        {translate('CLEAR_SEARCH')}
      </Button>
    </Stack>
  );
};

export default NoTripsFound;
